export default "__VITE_ASSET__45jwu7Bj__"